exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-c6fe0cc6]{line-height:24px;font-size:13px;color:#000026;font-weight:400;letter-spacing:0;font-family:Verdana,sans-serif;margin-bottom:16px;margin-top:-1rem;padding:24px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6fe0cc6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/SimpleContent.vue
// module id = 595
// module chunks = 0